import { OnSchedHelpers } from '../../utils/OnSchedHelpers'

export const CreateLocation = (element, response) => {
  if (response.error) {
      OnSchedHelpers.ThrowError(element, response);
      return;
  }
  
  var elLocationSetup = document.getElementById(element.id);
  var confirmationEvent = new CustomEvent("locationSetupComplete", { detail: response });
  elLocationSetup.dispatchEvent(confirmationEvent);    
  elLocationSetup.innerHTML = "";    

  OnSchedHelpers.UtilityCustomEvents.ElementLoaded(element);
}

export const ModifyLocation = (element, response) => {
  if (response.error) {
      OnSchedHelpers.ThrowError(element, response);
      return;
  }
  var elLocationSetup = document.getElementById(element.id);
  var confirmationEvent = new CustomEvent("locationSetupComplete", { detail: response });
  elLocationSetup.dispatchEvent(confirmationEvent);
  elLocationSetup.innerHTML = "";    

  OnSchedHelpers.UtilityCustomEvents.ElementLoaded(element);
}
